import WizardFooter from 'views/components/common/Wizard/Footer/WizardFooter';

export default WizardFooter;
